export default __webpack_public_path__ + "static/media/content.1220d536.png";